import styles from "./EventCategory.module.scss";
import classNames from "classnames";
import {useState} from "react";
import {EventCategoryProps} from "../../../../types/props";


export const EventCategory = ({categories, status} : EventCategoryProps) => {
    const [isClickedCategories, setIsClickedCategories] = useState<string[]>([]);
    let statusStyle = "";

    if(status === "Активно"){
        statusStyle = "active";
    }
    if(status === "На модерации" || status === "Черновик"){
        statusStyle = "moderation";
    }
    if(status === "Завершено" || status === "Отменено" || status === "Прекращено"){
        statusStyle = "finished";
    }

    const handleClick = (element: string) => {
        setIsClickedCategories(prev =>
            prev.includes(element)
                ? prev.filter(item => item !== element)
                : [...prev, element]
        );
    };

    return (
        <div className={styles.categoriesWrapper}>
            {Array.isArray(categories) && categories.map(category => (
                <button
                    key={category.id}
                    className={classNames(styles.category, {[styles.clicked]: isClickedCategories.includes(category.name)})}
                    onClick={() => handleClick(category.name)}>
                    <span>{category.name}</span>
                </button>
            ))}
            <button
                className={classNames(styles.status, styles[statusStyle], {[styles.clicked]: isClickedCategories.includes(statusStyle)})}
                onClick={() => handleClick(statusStyle)}>
                {status}
            </button>
        </div>
    )
}